import React, { useState } from 'react';

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div className="faq-question" style={{
        background: "transparent",
        padding: "1em"
      }} onClick={toggleOpen}>
        {question} <span className="arrow-icon">{isOpen ? '▼' : '▶'}</span>
      </div>
      {isOpen && <div className="faq-answer" style={{padding:"1em"}}>{answer}</div>}
    </div>
  );
};

export default FaqItem;